import script from "./TeamMember.vue?vue&type=script&lang=ts&setup=true"
export * from "./TeamMember.vue?vue&type=script&lang=ts&setup=true"

import "./TeamMember.vue?vue&type=style&index=0&id=d6661d36&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6661d36"]])

export default __exports__